export default __webpack_public_path__ + "maps-guides-styles-layers-symbol-layer-icon-1200-f91cf180e877da0ad95d51304dce8a86.webp";